export const comments_3399195 = {"data":{"data":[],"links":{}}}